import { MantineThemeOverride } from '@mantine/core';

export type ProgressTheme = NonNullable<MantineThemeOverride['components']>['Progress'];

export const Progress: ProgressTheme = {
  // todo: define
};
